const CONSTANTS = {
	SDK_URL: 'https://webapi.amap.com/maps',
	CALLBACK_NAME: 'aMapInitCallback'
}

export default CONSTANTS
